import { map } from 'rxjs';
import { getUnixTime } from 'date-fns';
import { ADMIN_API } from '../AdminAPI';
import { convertUnixToDate } from '@golden/gdk-base';
import { transferTransactionTypeMapAdminTransferTransactionType } from '../constants/transferTransactionTypeMapAdminTransferTransactionType';
import { isUndefined } from '@golden/utils';
export function createHistoryService(api) {
    return {
        getBetHistory(payload) {
            const data = { ...payload };
            if (data.start_at)
                data.start_at = getUnixTime(data.start_at);
            if (data.end_at)
                data.end_at = getUnixTime(data.end_at);
            return api.fetch(ADMIN_API.GET_BET_HISTORY, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'settled_at', 'original_created_at', 'game_start_at', 'last_synced_at'))
            })));
        },
        exportBetHistory(payload) {
            const { specify_league: SpecifyLeague, ...omitted } = payload;
            const data = {
                ...omitted,
                ...(SpecifyLeague ? { specify_league: JSON.stringify(SpecifyLeague) } : {})
            };
            if (data.start_at)
                data.start_at = getUnixTime(data.start_at);
            if (data.end_at)
                data.end_at = getUnixTime(data.end_at);
            return api.fetch(ADMIN_API.POST_EXPORT_BET_HISTORY_VALIDATE, { data });
        },
        getTransferHistory(payload) {
            const data = { ...payload };
            if (data.start)
                data.start = getUnixTime(data.start);
            if (data.end)
                data.end = getUnixTime(data.end);
            return api.fetch(ADMIN_API.GET_TRANSFER_HISTORY, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => ({
                    ...convertUnixToDate(item, 'created_at', 'finished_at'),
                    transaction_status: transferTransactionTypeMapAdminTransferTransactionType[item.transaction_status]
                }))
            })));
        },
        getTransferHistoryException(id) {
            return api.fetch(ADMIN_API.GET_TRANSFER_HISTORY_EXCEPTION, { config: { urlParams: { id } } });
        },
        checkTransfer(serialNumber) {
            return api.fetch(ADMIN_API.POST_CHECK_TRANSFER, { data: { transfer_number: serialNumber } });
        },
        confirmTransfer(id) {
            return api.fetch(ADMIN_API.POST_TRANSFER_HISTORY_CONFIRM, { config: { urlParams: { id } } });
        },
        cancelTransfer(id) {
            return api.fetch(ADMIN_API.POST_TRANSFER_HISTORY_CANCEL, { config: { urlParams: { id } } });
        },
        getOperationHistory(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_OPERATION_HISTORY, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'operate_at'))
            })));
        },
        getIpHistory(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_IP_HITSOTRY, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'login_at'))
            })));
        },
        getGameLoginHistory(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_GAME_LOGIN_HISTORY, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'login_at'))
            })));
        },
        getManagerLoginHistory(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            const API = (data.identity === 'admin') ? ADMIN_API.GET_ADMIN_LOGIN_HISTORY : ADMIN_API.GET_AGENT_LOGIN_HISTORY;
            return api.fetch(API, { data }).pipe(map((res) => ({
                ...res,
                identity: data.identity,
                data: res.data.map((item) => convertUnixToDate(item, 'login_at'))
            })));
        },
        getGameLoginHistoryDetail(id, data) {
            return api.fetch(ADMIN_API.GET_GAME_LOGIN_HISTORY_DETAIL, { data, config: { urlParams: { id } } });
        },
        getIpMonitoringHistory(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_IP_MONITORING_HISTORY, { data }).pipe(map((item) => (item.map((list) => ({
                ...list,
                histories: list.histories.map((history) => convertUnixToDate(history, 'last_login_at'))
            })))));
        },
        getPlayerProfitHistory(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_PLAYER_PROFIT_HISTORY, { data });
        },
        getPlayerProfitHistoryCsvByCsv(payload) {
            const data = new FormData();
            data.append('file', payload.file);
            return api.fetch(ADMIN_API.POST_PLAYER_REPORT_REVENUE_CHECK_CSV, { data });
        },
        downloadPlayerProfitHistoryCsv(payload) {
            const data = new FormData();
            data.append('file', payload.file);
            data.append('search_type', payload.search_type);
            data.append('start_at', getUnixTime(payload.start_at).toString());
            data.append('end_at', getUnixTime(payload.end_at).toString());
            data.append('filter_zero_cash', payload.filter_zero_cash ? '1' : '0');
            if (!isUndefined(payload.is_activity_excluding)) {
                data.append('is_activity_excluding', payload.is_activity_excluding ? '1' : '0');
            }
            if (payload.specify_league) {
                data.append('specify_league', payload.specify_league);
            }
            if (payload?.game_categories)
                payload.game_categories.forEach((category) => data.append('game_categories[]', category.toString()));
            if (payload?.game_id)
                data.append('game_id', payload.game_id.toString());
            if (payload?.channel_id)
                payload.channel_id.forEach((id) => data.append('channel_id[]', id.toString()));
            return api.fetch(ADMIN_API.POST_EXPORT_PLAYER_REVENUE_VALIDATE, { data });
        },
        getProfitHistoryTeam(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_PROFIT_HISTORY_TEAM, { data });
        },
        getProfitHistoryGame(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_PROFIT_HISTORY_GAMES, { data });
        },
        getProfitHistoryAgent(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_PROFIT_HISTORY_AGENTS, { data });
        },
        getProfitHistoryFinanceFeeGoldenDetails(payload) {
            const data = {
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_PROFIT_HISTORY_FINANCE_FEE_GOLDEN_DETAILS, { data });
        },
        getProfitHistoryFinanceFeeAgentsDetails(agent_id, payload) {
            const data = {
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_PROFIT_HISTORY_FINANCE_FEE_AGENTS_DETAILS, { data, config: { urlParams: { agent_id } } });
        },
        getProfitHistoryFinanceFeePlayersDetails(user_id, payload) {
            const data = {
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_PROFIT_HISTORY_FINANCE_FEE_PLAYERS_DETAILS, { data, config: { urlParams: { user_id } } });
        },
        getProfitLayer(id, payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_PROFIT_LAYER_INFO, { data, config: { urlParams: { id } } });
        },
        getProfitLayerChildren(id, payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_PROFIT_LAYER_INFO_CHILDREN, { data, config: { urlParams: { id } } });
        },
        getProfitGolden(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_PROFIT_GOLDEN_INFO, { data });
        },
        getProfitGoldenChildren(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_PROFIT_GOLDEN_INFO_CHILDREN, { data });
        },
        getDepositStatistic(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_DEPOSIT_STATISTIC, { data });
        },
        getDepositStatisticDetail(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_DEPOSIT_STATISTIC_DETAIL, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'updated_at'))
            })));
        },
        getNewPeopleStatistic(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_NEW_PLAYER_STATISTIC, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'register_at'))
            })));
        },
        getCashLog(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_CASH_LOG, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => ({
                    ...convertUnixToDate(item, 'updated_at'),
                    balances: item.balances.map((record) => convertUnixToDate(record, 'fetched_at'))
                }))
            })));
        },
        getRevenueSnapshot(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_REVENUE_SNAPSHOT, { data }).pipe(map((res) => ({
                revenue: res.revenue.map((item) => convertUnixToDate(item, 'date'))
            })));
        },
        getRevenueTrend(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_REVENUE_TREND, { data }).pipe(map((res) => ({
                revenue: (res.revenue).map((item) => convertUnixToDate(item, 'date'))
            })));
        },
        getInAndOutPlatform(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_IN_AND_OUT_PLATFORM, { data });
        },
        getInAndOutRevenue(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_IN_AND_OUT_REVENUE, { data });
        },
        getInAndOutDepositAndWithdraw(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_IN_AND_OUT_DEPOSIT_AND_WITHDRAW, { data });
        },
        getInAndOutTransfer(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_IN_AND_OUT_TRANSFER, { data });
        },
        getPlatformFeeDailyRecords(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_PLATFORM_FEE_DAILY_RECORDS, { data }).pipe(map((res) => res.map((item) => convertUnixToDate(item, 'start_at', 'end_at'))));
        },
        getCashAccountingUserStatistic(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_CASH_ACCOUNTING_USER_STATISTIC, { data });
        },
        getCashAccountingBetHistoryStatistic(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_CASH_ACCOUNTING_BET_HISTORY_STATISTIC, { data });
        },
        getAgentOperationLog(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_AGENT_OPERATION_LOG, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'operated_at'))
            })));
        },
        getPlayerLeaderboardAll() {
            return api.fetch(ADMIN_API.GET_LEADERBOARD_ALL);
        },
        getPlayerLeaderboardCategories() {
            return api.fetch(ADMIN_API.GET_LEADERBOARD_CATEGORIES);
        },
        getPlayerLeaderboardDetailAll(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_LEADERBOARD_DETAIL_ALL, { data });
        },
        getPlayerLeaderboardDetailCategories(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_LEADERBOARD_DETAIL_CATEGORIES, { data });
        },
        getWinlossAnalyze(data) {
            return api.fetch(ADMIN_API.GET_PLAYER_REPORT_WINLOSS_ANALYZE, { data });
        },
        getFeedbackHistory(payload) {
            const data = { ...payload };
            if (data.start_at)
                data.start_at = getUnixTime(data.start_at);
            if (data.end_at)
                data.end_at = getUnixTime(data.end_at);
            return api.fetch(ADMIN_API.GET_FEEDBACK_HISTORY, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at', 'date'))
            })));
        },
        getUserWalletLocks(payload) {
            return api.fetch(ADMIN_API.GET_USER_WALLET_LOCKS, { data: payload });
        },
        getGashLog(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_GASH_LOGS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at'))
            })));
        },
        exportGashLog(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_EXPORT_GASH_LOG, { data, config: { responseType: 'blob' } });
        },
        getGashUserInfo(data) {
            return api.fetch(ADMIN_API.GET_GASH_USER_INFO, { data });
        },
        postGashReclaim(data) {
            return api.fetch(ADMIN_API.POST_GASH_RECLAIM, { data });
        },
        postGashGrant(data) {
            return api.fetch(ADMIN_API.POST_GASH_GRANT, { data });
        }
    };
}
//# sourceMappingURL=HistoryService.js.map